import type { RouteRecordRaw } from 'vue-router'
import heroIconGlobal from '@/assets/icons/hero-logo-global.png'
import heroIconCn from '@/assets/icons/hero-logo-cn.png'
import heroIconEn from '@/assets/icons/hero-logo-en-red.png'
import heroLogo from '@/assets/light/index/pc-logo.png'

import { dictPicDefault, dictPicDnaGlobal } from "@/common/desktopTipsStatic";
import { DictPicDefault } from "@/@types/types";

export class CommonConstants {
  static readonly PHONE_REGEX_SIMPLE: RegExp = /^1\d{10}$/;

  static readonly KE_FU_URL: string = 'https://kf.yingxiong.com/kf2.0/user-center'

  static readonly IS_AREA: string = process.env.VUE_APP_AREA || 'global'

  static readonly IS_CN: boolean = process.env.VUE_APP_AREA === 'cn'

  static readonly MALL_STATIC_URL: string = 'https://mallstatic.herogame.com/mall-static'

  private static getPrivacyProtocol(): string {
    const PRIVACY_URLS = {
      CN: 'https://www.yingxiong.com/p/per_adu.html',
      GLOBAL: 'https://www.yingxiong.com/p/privacy_globalmall.html'
    };

    const GAME_SPECIFIC_URLS: Record<string, string> = {
      dnaGlobal: 'https://duetnightabyss.herogame.com/en/#/news/content?id=6266'
    };

    if (CommonConstants.IS_CN) {
      return PRIVACY_URLS.CN;
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return GAME_SPECIFIC_URLS[currentGame] ?? PRIVACY_URLS.GLOBAL;
  }

  // 隐私协议
  static get GLOBAL_PRIVACY_PROTOCOL(): string {
    return this.getPrivacyProtocol()
  }

  private static getUserProtocol() {
    const USER_PRIVACY_URLS = {
      CN: 'https://www.yingxiong.com/p/yxyhxy.html',
      GLOBAL: 'https://www.yingxiong.com/p/service_globalmall.html'
    };

    const GAME_SPECIFIC_URLS: Record<string, string> = {
      dnaGlobal: 'https://duetnightabyss.herogame.com/en/#/news/content?id=6268'
    };

    if (CommonConstants.IS_CN) {
      return USER_PRIVACY_URLS.CN;
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return GAME_SPECIFIC_URLS[currentGame] ?? USER_PRIVACY_URLS.GLOBAL;
  }

  // 用户协议
  static get GLOBAL_USER_PROTOCOL(): string {
    return this.getUserProtocol()
  }

  static readonly GLOBAL_JOIN_US: string =
    process.env.VUE_APP_AREA === 'global'
      ? 'https://app.mokahr.com/social-recruitment/yingxionghr/39426#/'
      : 'https://www.yingxiong.com/p/join.html'


  // header 部分logo
  private static getGameLogoHeader(): string {
    const GAME_LOGO_MAP: Readonly<Record<string, string>> = {
      dnaGlobal: `${CommonConstants.MALL_STATIC_URL}/hero-logo-global.png`
    };

    if (CommonConstants.IS_AREA === 'cn') {
      return heroIconCn;
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    // 返回对应游戏logo或默认全局logo
    return GAME_LOGO_MAP[currentGame] ?? heroIconGlobal;
  }

  static get GAME_LOGO_HEADER(): string {
    return this.getGameLogoHeader()
  }

  private static getGameLogo() {
    const GAME_LOGO_MAP: Readonly<Record<string, string>> = {
      dnaGlobal: `${CommonConstants.MALL_STATIC_URL}/hero-logo-en-red.png`
    };

    if (CommonConstants.IS_AREA === 'cn') {
      return heroLogo
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return GAME_LOGO_MAP[currentGame] ?? heroIconEn
  }

  static get GAME_LOGO(): string {
    return this.getGameLogo()
  }

  private static getDefaultRoute() {
    const routeDirectTopup: RouteRecordRaw = {
      path: '/',
      redirect: '/topup'
    }

    const routeDefault: RouteRecordRaw = {
      path: '/',
      name: 'Home',
      component: CommonConstants.IS_CN
      ? () => import('@/views/home/index.vue')
      : () => import('@/views/home/newHome.vue'),
    }

    const routeMap: Record<string, RouteRecordRaw> = {
      dnaGlobal: routeDirectTopup,
      default: routeDefault
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return routeMap[currentGame] ?? routeDefault
  }

  static get DEFAULT_ROUTE(): RouteRecordRaw {
    return this.getDefaultRoute()
  }

  private static getHeaderHeightPC() {
    const HEADER_HEIGHT_PC: Record<string, string> = {
      default: 'h-[58px]',
      dnaGlobal: 'h-[58px]'
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return HEADER_HEIGHT_PC[currentGame] ?? HEADER_HEIGHT_PC.default;
  }

  static get HEADER_HEIGHT_PC(): string {
    return this.getHeaderHeightPC()
  }

  private static getHeaderHeightMobile() {
    const HEADER_HEIGHT_MOBILE: Record<string, string> = {
      default: 'h-[44px]',
      dnaGlobal: 'h-[44px]'
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return HEADER_HEIGHT_MOBILE[currentGame] ?? HEADER_HEIGHT_MOBILE.default;
  }

  static get HEADER_HEIGHT_MOBILE(): string {
    return this.getHeaderHeightMobile()
  }

  private static getHeaderLogoHeightPC() {
    const HEADER_LOGO_HEIGHT_PC: Record<string, string> = {
      default: 'h-[40px]',
      dnaGlobal: 'h-[40px]'
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return HEADER_LOGO_HEIGHT_PC[currentGame] ?? HEADER_LOGO_HEIGHT_PC.default;
  }

  static get HEADER_LOGO_HEIGHT_PC(): string {
    return this.getHeaderLogoHeightPC()
  }

  private static getHeaderLogoHeightMobile() {
    const HEADER_LOGO_HEIGHT_MOBILE: Record<string, string> = {
      default: 'h-[24px]',
      dnaGlobal: 'h-[24px]'
    }

    if (CommonConstants.IS_CN) {
      return 'h-[28px]'
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return HEADER_LOGO_HEIGHT_MOBILE[currentGame] ?? HEADER_LOGO_HEIGHT_MOBILE.default;
  }

  static get HEADER_LOGO_HEIGHT_MOBILE(): string {
    return this.getHeaderLogoHeightMobile()
  }

  private static getFooterLogoHeightPC() {
    const FOOTER_LOGO_HEIGHT_PC: Record<string, string> = {
      default: 'h-[50px]',
      dnaGlobal: 'h-[50px]'
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return FOOTER_LOGO_HEIGHT_PC[currentGame] ?? FOOTER_LOGO_HEIGHT_PC.default;
  }

  static get FOOTER_LOGO_HEIGHT_PC(): string {
    return this.getFooterLogoHeightPC()
  }

  private static getFooterLogoHeightMobile() {
    const FOOTER_LOGO_HEIGHT_MOBILE: Record<string, string> = {
      default: 'w-[85px]',
      dnaGlobal: 'w-[85px]'
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return FOOTER_LOGO_HEIGHT_MOBILE[currentGame] ?? FOOTER_LOGO_HEIGHT_MOBILE.default;
  }

  static get FOOTER_LOGO_HEIGHT_MOBILE(): string {
    return this.getFooterLogoHeightMobile()
  }

  private static getLoginLogoHeightPC() {
    const LOGIN_LOGO_HEIGHT_PC: Record<string, string> = {
      default: 'h-[51px]',
      dnaGlobal: 'h-[51px]'
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return LOGIN_LOGO_HEIGHT_PC[currentGame] ?? LOGIN_LOGO_HEIGHT_PC.default;
  }

  static get LOGIN_LOGO_HEIGHT_PC(): string {
    return this.getLoginLogoHeightPC()
  }

  private static getLoginLogoHeightMobile() {
    const LOGIN_LOGO_HEIGHT_MOBILE: Record<string, string> = {
      default: 'h-[41px]',
      dnaGlobal: 'h-[41px]'
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return LOGIN_LOGO_HEIGHT_MOBILE[currentGame] ?? LOGIN_LOGO_HEIGHT_MOBILE.default;
  }

  static get LOGIN_LOGO_HEIGHT_MOBILE(): string {
    return this.getLoginLogoHeightMobile()
  }

  private static getDeskTopTipsPic(): DictPicDefault {
    const DESKTOP_TIPS_PIC: Record<string, DictPicDefault> = {
      default: dictPicDefault,
      dnaGlobal: dictPicDnaGlobal
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return DESKTOP_TIPS_PIC[currentGame] ?? DESKTOP_TIPS_PIC.default;
  }

  static get DESKTOP_TIPS_PIC(): DictPicDefault {
    return this.getDeskTopTipsPic()
  }
}
